import { createSlice } from '@reduxjs/toolkit';

import { ProductBrandDto } from '../../../../types/products';
import { SLICE_BASE_NAME } from '../../auth/constant';

const initialState: ProductBrandDto = {
  name: '',
  description: '',
};

const brandSlice = createSlice({
  name: `${SLICE_BASE_NAME}/products/brands`,
  initialState,
  reducers: {
    addBrand(state, action) {
      state.name = action.payload.name;
      state.description = action.payload.description;
    },
  },
});

export const { addBrand } = brandSlice.actions;
export default brandSlice.reducer;
